import React from 'react';
import styled from 'astroturf/react';
import { Pill } from 'js/social/shared/design_system/Pill';
import _Container from "FeedFilters-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/FeedFilters.tsx?styleId=Container";


const Container = /*#__PURE__*/styled("div", null, {
  displayName: "Container",
  styles: _Container
});

type Props = {
  filter?: string;
  filters: string[];
  onFilterChange: (filter?: string) => void;
};

export const FeedFilters: React.FC<Props> = ({
  filter,
  filters,
  onFilterChange,
}) => {
  const camelToTitleCase = (text: string) => {
    const spaced = text.replace(/([A-Z])/g, ' $1');
    return spaced[0].toUpperCase() + spaced.slice(1);
  };

  return (
    <Container>
      <Pill
        active={filter === undefined}
        onClick={() => onFilterChange(undefined)}
      >
        All Activity
      </Pill>

      {filters.map((name) => (
        <Pill
          key={name}
          active={filter === name}
          onClick={() => onFilterChange(name)}
        >
          {camelToTitleCase(name)}
        </Pill>
      ))}
    </Container>
  );
};
